"use strict";

var _classCallCheck = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NodeNames_1 = require("../enum/NodeNames");

var Params_1 = require("../utils/Params");

var AbstractNode_1 = require("./abstract/AbstractNode");

var ReturnNode =
/*#__PURE__*/
function (_AbstractNode_1$defau) {
  _inherits(ReturnNode, _AbstractNode_1$defau);

  function ReturnNode(token) {
    var _this;

    _classCallCheck(this, ReturnNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReturnNode).call(this, NodeNames_1.default.Return, token));
    _this.params = Params_1.paramParser(token.start, token.end, token.params);
    return _this;
  }

  return ReturnNode;
}(AbstractNode_1.default);

exports.default = ReturnNode;